/**
 * Push away edge tip elements (currently circles or arrow heads) from the node a bit
 */
export const EDGE_TIP_ELEMENT_DISTANCE_FROM_NODE = 2;
export const EDGE_ARROW_HEAD_HEIGHT = 15;
export const EDGE_DEFAULT_THICKNESS = 1;
export const EDGE_HIT_AREA_THICKNESS = 10;
export const EDGE_SHIFT_MULTIPLIER = 20;
export const ICON_DEFAULT_FOREGROUND_COLOR = '#fff';
export const ICON_DEFAULT_ACCENT_COLOR = '#c05046';
export const MAX_MAIN_SEGMENT_DISTANCE = 30;
